(function() {
    'use strict';

    angular.module('aprima-provider-api').factory('GatewayService', [
        '$q',
        'GatewayServiceTs',
        GatewayService
    ]);

    function GatewayService(
        $q,
        GatewayServiceTs
    ) {
        return {
            findClientServer: findClientServer,
        };

        function findClientServer(clientId, gatewayPrefix) {
            var promise = GatewayServiceTs.findClientServer(clientId, gatewayPrefix).toPromise();
            return $q.when(promise);
        }
    }
})();